<template>
<div class="qq">
  <div class="index_top fcolumn">
    <div class="top_logos frow">
      <div class="top_logo">
        <img class="logo_img" :src="require('@/assets/images/index_04.png')" mode="widthFix">
      </div>
      <div class="top_right">
        <div class="top_name">桃江农商银行</div>
        <div class="top_e">TAOJIANG RURAL COMMERCIAL BANK</div>
      </div>
    </div>
    <div class="top_title">{{title}}</div>
  </div>
  <div class="btn frow btn1" @click="goto()">
    <img class="btn_img" :src="require('@/assets/images/index_02.png')" mode="widthFix">立即报名
  </div>
  <div class="btn frow btn2" @click="check('/Search')">
    <img class="btn_img" :src="require('@/assets/images/index_03.png')" mode="widthFix">查询结果
  </div>
  <div class="index_bottom fcolumn">
    <div class="bottom_name">桃江农商银行</div>
    <div class="bottom_code">Copyright © 2022 桃江农商银行</div>
  </div>
  <div class="c-message" :class="message.status" v-show="message.show">
      <div class="c-message--main">
          <i class="c-message--icon" :class="message.type"></i>
          <div class="c-message--tip">{{message.text}}</div>
          <div class="c-message--tip">{{messages2}}</div>
      </div>
  </div>
</div>

</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      msg: '',
      title:'',
      canSign:true,
      messages:'',
      messages2:'',
      message: {
        show: '',
        type: '',
        status: '',
        text: '',
        time: '',
        timeout: ''
      },
    }
  },
  methods:{
    goto(){
      var id = localStorage.getItem('id');
      if(this.canSign){
        this.$router.push('/SignUp?id=' + id);
      }else{
        this.$request.Alert(this,this.messages, 'info', '3500');
      }
    },
    check(page){
        this.$router.push(page);

    },
    getBaseData(){
        var id = localStorage.getItem('id');
        var config = {};
        this.$request.get('/api/apply/get-data/' + id, {},config, response => {
            if(response.data.code == 200){
              this.title = response.data.data.name;
              localStorage.setItem('title',response.data.data.name);
            }else if(response.data.code == 260){
              this.canSign = false;
              this.messages = response.data.message+'。';
              this.messages2 = '开始时间：'+ response.data.data.start_time;
              this.title = response.data.data.name;
              localStorage.setItem('title',response.data.data.name);
            }else if(response.data.code == 270){
              this.canSign = false;
              this.messages = response.data.message+'。';
              this.messages2 = '截止时间：'+ response.data.data.deadline;
              this.title = response.data.data.name;
              localStorage.setItem('title',response.data.data.name);
            }else if(response.data.code == 280){
              this.canSign = false;
              this.messages = response.data.message;
              this.title = response.data.data.name;
              localStorage.setItem('title',response.data.data.name);
            }
        }, error => {
            console.log(error)
        });
    },
  },
  mounted() {
    localStorage.setItem('id',8);
    // localStorage.setItem('id',this.$route.query.id);
    this.getBaseData();
    // var aa = JSON.parse(localStorage.getItem('info'));
    // console.log('缓存',aa);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only --> 
<style scoped>
  .index_top{
    width:100%;
    background: #940709;
    height:150px;
    margin-bottom:100px;
  }
  .top_logos{
    padding:10px 5%;
  }
  .top_logo{
    width:100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logo_img{
    width:69px;
    height:69px;
  }
  .top_right{
    color:white;
  }
  .top_name{
    height:40px;
    font-weight: bold;
    font-size:25px;
    line-height:40px;
    letter-spacing:10px;
  }
  .top_e{
    height:40px;
    font-size:10px;
    line-height:40px;
    margin-top:-5px;
  }
  .top_title{
    height:50px;
    background: #940709;
    color:white;
    font-weight: bold;
    font-size:23px;
    text-align: center;
    line-height:50px;
  }
  .btn{
    width:80%;
    margin:50px auto;
    height:60px;
    justify-content: center;
    align-items: center;
    border-radius:5px;
    font-size:20px;
  }
  .btn_img{
    width:25px;
    height:25px;
    margin-right:10px;
  }
  .btn1{
    background:#940709;
    color:white;
  }
  .btn2{
    border:1px solid #940709;
    color:#940709;
  }
  .index_bottom{
    width:500px;
    height:40px;
    border-top:5px solid #E6E6E6;
    color:#999999;
    font-size:12px;
    position: fixed;
    bottom:0;
    padding:10px 0;
  }
  .bottom_name{
    height:20px;
    line-height:20px;
    text-align: center;
    font-weight: bold;
  }
  .bottom_code{
    height:25px;
    line-height:25px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue